module.exports = __webpack_public_path__ + "static/img/product-6.ae13445.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/images/product-6.png
// module id = Ayy8
// module chunks = 1